import DataService from '@/service/DataService'


const state =  {
  status: {},
  messages: []
}


const getters = {
  messagesStatus: (state) => state.status,
  messages: (state) => state.messages
};

const actions = {
  // GET
  getAllMessages({ commit }) {
    commit('GETALLMESSAGESREQUEST')

    return DataService.getAllUserMessages()
      .then(res => {
        commit('GETALLMESSAGESSUCCESS', res.data)
      })
      .catch(() => {
        commit('GETALLMESSAGESFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
      }) 
  },
  getNewMessages({ commit }) {
    commit('GETNEWMESSAGESREQUEST')

    return DataService.getNewUserMessages()
      .then(res => {
        commit('GETNEWMESSAGESSUCCESS', res.data)
      })
      .catch(() => {
        commit('GETNEWMESSAGESFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
        // commit('GETNEWMESSAGESFAILURE', err)
      })
  },

  // POST
  // createKontakt ({ commit }, kontakt) {
  //   commit('CREATEKONTAKTREQUEST')

  //   return DataService.createContact(kontakt)
  //     .then(res => {
  //       commit('CREATEKONTAKTSUCCESS', res.data)
  //     }).catch(() => {
  //       commit('CREATEKONTAKTFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
  //     })
  // },

  // PUT
  updateMessage ({ commit }, message) {
    commit('UPDATEMESSAGEREQUEST')

    return DataService.updateUserMessage(message)
      .then(() => {
        commit('UPDATEMESSAGESUCCESS')
      })
      .catch(err => {
        commit('UPDATEMESSAGEFAILURE', err)
      })
  },

  // DELETE
  deleteMessage ({ commit }, messageId) {
    commit('DELETEMESSAGEREQUEST')

    return DataService.deleteUserMessage(messageId)
      .then(() => {
        commit('DELETEMESSAGESUCCESS', messageId)
      })
      .catch(() => {
        commit('DELETEMESSAGEFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
      })
  }
};

const mutations = {
  // GET
  GETALLMESSAGESREQUEST: (state) => {state.status = { getAllMessages: true }},
  GETALLMESSAGESSUCCESS: (state, res) => {
    state.status = {}
    state.messages = res
  },
  GETALLMESSAGESFAILURE: (state, err) => {state.status = {errMsg: err}},
  GETNEWMESSAGESREQUEST: (state) => {state.status = { getNewMessages: true }},
  GETNEWMESSAGESSUCCESS: (state, res) => {
    if (res.length === 0) {
      state.status = { noNewMessages: true }
    } else {
      state.status = {}
      if (state.messages.length === 0) {
        state.messages = res
      } else {
        res.forEach(e => state.messages.unshift(e))
      }
    }
  },
  GETNEWMESSAGESFAILURE: (state, err) => {state.status = {errMsg: err}},

  // POST

  // PUT
  UPDATEMESSAGEREQUEST: (state) => {state.status = { updatingMessage: true }},
  UPDATEMESSAGESUCCESS: (state) => {
    state.status = {}
  },
  UPDATEMESSAGEFAILURE: (state, err) => {state.status = { errMsg: err }},

  // DELETE
  DELETEMESSAGEREQUEST: (state) => {state.status = { deletingMessage: true }},
  DELETEMESSAGESUCCESS: (state, messageId) => {
    state.status = {}
    let element = state.messages.findIndex(el => el.id === messageId)
    state.messages.splice(element, 1)
  },
  DELETEMESSAGEFAILURE: (state, err) => {state.status = { errMsg: err }}
};

export default {
  state,
  getters,
  actions,
  mutations
}